import YoutubeVideo from './YoutubeVideo';
import VimeoVideo from './VimeoVideo';
import Html5Video from './Html5Video';

export default class VideoPlayer {
  constructor(el, type) {
    switch (type) {
      case 'youtube':
        this._video = new YoutubeVideo(el);
        break;
      case 'vimeo':
        this._video = new VimeoVideo(el);
        break;
      case 'html5':
        this._video = new Html5Video(el);
        break;
      default:
        this._video = null;
        console.warn('Video type was not specified. Must be either: youtube, vimeo, or html5');
        break;
    }

    this._onCorePauseMedia = (event) => {
      const { exclude } = event.detail;
      let shouldPause = true;

      if (Array.isArray(exclude) && exclude.some(e => e === el)) {
        shouldPause = false;
      } else if (exclude === el) {
        shouldPause = false;
      }

      if (shouldPause) {
        this.pause();
      }
    }

    document.body.addEventListener('core:pause-media', this._onCorePauseMedia);
  }

  /**
   * Play the video and dispatch video-related events based on resolve/reject from Promise
   * @public
   */
  play() {
    if (this._video) {
      this._video.play();
    }
  }

  /**
   * Pause the video
   * @public
   */
  pause() {
    if (this._video) {
      this._video.pause();
    }
  }

  /**
   * Unload the video
   */
  unload() {
    if (this._video) {
      this._video.unload();
    }

    document.body.removeEventListener('core:pause-media', this._onCorePauseMedia);
  }
}
